import { atom } from "recoil";
export const checkoutsAtom = atom({
  key: "checkoutsAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
